<template>
  <BaseWarning>
  <i18n path="warnings.overlap.baseWarning">
    <template #overlapType>
      {{ $t(`warnings.overlap.${data.overlapType}`) }}
    </template>

    <template #flank>
      {{ $t(`tactics.pitchAreas.${data.side}Flank`) }}
    </template>

    <template #overlappingPartnerships>
      <a href="${detailURL}" target="_blank">
        {{ $t('warnings.overlap.overlappingPartnerships') }}
      </a>
    </template>
  </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from './BaseWarning'

export default {
  name: 'WarningOverlap',
  props:  ['data'],
  components: { BaseWarning }
}
</script>
